import { Visibility } from '@skedulo/protobuf-web/dist/ui/crud/v1/actions.js'
import { ViewType } from '@skedulo/protobuf-web/dist/ui/crud/v1/viewstates.js'
import { DEFAULT_VIEW_STATE_ID } from '../constants'
import { Scope } from '../types'
import type { IViewState } from '../../index'

/**
 * Returns true if the given view state is considered "empty".
 */
export const isEmptyViewState = (viewState: IViewState): boolean => {
  return !viewState || viewState.id === '' || viewState.isDefault === true
}

export const orderViewStatesByName = (a: IViewState, b: IViewState) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
  return 0
}

export const getEmptyViewStateForScope = (
  type: ViewType | undefined,
  scope: Scope,
): IViewState => {
  return {
    id: DEFAULT_VIEW_STATE_ID,
    visibility: Visibility.SYSTEM,
    viewTypeId: type?.id ?? '',
    scope: scope?.scope,
    name: 'Default view',
    data: {},
    systemInformation: undefined,
    isSystemGenerated: false,
    isDefault: true,
  }
}
